import { QR_LOGIN_CREATE_REQUEST } from "shared/actions/constants";

import { useAppDispatch } from "app/hooks";
import { useSelectedLab } from "hooks/useSelectedLabStation";

const BadgePage = () => {
  const dispatch = useAppDispatch();
  const selectedLab = useSelectedLab();

  return (
    <div className="BadgePage">
      <button
        onClick={() => {
          dispatch({
            type: QR_LOGIN_CREATE_REQUEST,
            payload: { lab_id: selectedLab.id },
          });
        }}
      >
        Create Badge
      </button>
    </div>
  );
};

export default BadgePage;
